import { cepMask } from 'utils/masks';

export const carregarEnderecoApi = (endereco, cep, setValue, setError, getNomeCampo) => {
  const inputPreenchido = {};
  Object.keys(endereco).forEach(key => {
    if (endereco[key] !== null) inputPreenchido[key] = true;
  });
  setValue(getNomeCampo('cep'), cep);
  setValue(getNomeCampo('logradouro'), endereco.logradouro);
  setValue(getNomeCampo('bairro'), endereco.bairro);
  setValue(getNomeCampo('cidade'), endereco.cidade);
  setValue(getNomeCampo('estado'), endereco.estado);
  setValue(getNomeCampo('pais'), endereco.pais);
  setValue(getNomeCampo('complemento'), endereco.complemento);
  clearErro(setError, getNomeCampo);
  return { disabled: inputPreenchido, endereco };
};

const clearFields = (setValue, getNomeCampo) => {
  setValue(getNomeCampo('logradouro'), '');
  setValue(getNomeCampo('bairro'), '');
  setValue(getNomeCampo('cidade'), '');
  setValue(getNomeCampo('estado'), '');
  setValue(getNomeCampo('complemento'), '');
  setValue(getNomeCampo('numero'), '');
  setValue(getNomeCampo('pais'), '');
};

const clearErro = (setError, getNomeCampo) => {
  setError(getNomeCampo('logradouro'), { type: 'Clear', message: '' });
  setError(getNomeCampo('bairro'), { type: 'Clear', message: '' });
  setError(getNomeCampo('cidade'), { type: 'Clear', message: '' });
  setError(getNomeCampo('estado'), { type: 'Clear', message: '' });
  setError(getNomeCampo('pais'), { type: 'Clear', message: '' });
};

export const changeCep = (event, onChange, setValue, buscarEndereco, getNomeCampo) => {
  const value = cepMask(event.target.value);
  onChange({
    target: {
      name: event.target.name,
      value: value,
    },
  });

  if (value?.length === 9 || value?.length === 0) {
    clearFields(setValue, getNomeCampo);
    if (value?.length === 9) buscarEndereco(value);
  }
  return value;
};
